module.exports = __webpack_public_path__ + "static/media/acorn.d086ce20.png";